const creditAnalysisChartConst = {
  pod: {
    id: 'pod',
    title: 'Credit Stress Measure',
    // subTitle: 'Credit Stress Measure',
    data: [],
    type: 'CreditLineChart',
    lineKeys: [
      'pod',
      'peer_pod',
      'equity_price',
      'pod_compare1',
      'pod_compare2',
      'pod_compare3',
    ],
    tooltipInfo: {
      title: 'Credit Stress Measure',
      // subTitle: 'Credit Stress Measure',
    },
  },
  driver: {
    id: 'driver',
    title: 'Driver',
    subTitle: '',
    data: [],
    type: 'CreditLineChart',
    lineKeys: ['asset_volatility', 'leverage', 'asset_market_value'],
    tooltipInfo: {
      title: 'Driver',
      subTitle: '',
    },
  },
  impliedRating: {
    id: 'impliedRating',
    data: [],
    type: 'ImpliedRatingChart',
  },
}

export default creditAnalysisChartConst
